import type { SensoreDinamicoDTO } from '../../dto/plc/sensore-dinamico-dto'
import type { DynamicSensor } from '../../types/plc/dynamic-sensor'

const mapToDynamicSensor = (dto: SensoreDinamicoDTO): DynamicSensor => {
    return {
        id: dto.id,
        group: dto.gruppo ?? undefined,
        position: dto.posizione ?? undefined,
        name: dto.aliasId ?? undefined,
        enabled: dto.abilitato,
        number: dto.numero,
        resolution: dto.risoluzione,
        directionX: dto.directionX,
        directionY: dto.directionY,
        directionZ: dto.directionZ,
        rotationX: dto.rotationX,
        rotationY: dto.rotationY,
        rotationZ: dto.rotationZ,
        thresholdXYAcc: dto.sogliaXYAcc,
        thresholdZAcc: dto.sogliaZAcc,
        thresholdAccRipCount: dto.sogliaAccRipCount,
        timeThresholdAccReset: dto.timeSogliaAccReset ?? undefined,
        uom: dto.um ?? undefined,
        maxScale: dto.fondoScalaMax,
        minScale: dto.fondoScalaMin,
        arrayIndex: dto.arrayIndex,
        gravityAxes: dto.gravityAxes,
        offset1: dto.offset1,
        axis1: dto.asse1 ?? undefined,
        axis2: dto.asse2 ?? undefined,
        axis3: dto.asse3 ?? undefined,
    }
}

const mapToSensoreDinamicoDTO = (sensor: DynamicSensor): SensoreDinamicoDTO => {
    return {
        id: sensor.id,
        gruppo: sensor.group ?? null,
        posizione: sensor.position ?? null,
        aliasId: sensor.name ?? null,
        abilitato: sensor.enabled,
        numero: sensor.number,
        risoluzione: sensor.resolution,
        directionX: sensor.directionX,
        directionY: sensor.directionY,
        directionZ: sensor.directionZ,
        rotationX: sensor.rotationX,
        rotationY: sensor.rotationY,
        rotationZ: sensor.rotationZ,
        sogliaXYAcc: sensor.thresholdXYAcc,
        sogliaZAcc: sensor.thresholdZAcc,
        sogliaAccRipCount: sensor.thresholdAccRipCount,
        timeSogliaAccReset: sensor.timeThresholdAccReset ?? null,
        um: sensor.uom ?? null,
        fondoScalaMin: sensor.minScale,
        fondoScalaMax: sensor.maxScale,
        arrayIndex: sensor.arrayIndex,
        gravityAxes: sensor.gravityAxes,
        offset1: sensor.offset1,
        asse1: sensor.axis1 ?? null,
        asse2: sensor.axis2 ?? null,
        asse3: sensor.axis3 ?? null,
    }
}

export { mapToDynamicSensor, mapToSensoreDinamicoDTO }
